import { takeEvery, takeLatest, put, call } from "redux-saga/effects"
import { toast } from "react-toastify";

import { deleteGoalAPI, getAllDealTransactionAPI, getAllTransactionAPI, getGoalAPI, getTransactionAPI, postGoalAPI } from "../../helpers/backend_helper"
import { addNewGoalError, addNewGoalSuccess, deleteAgentGoalFail, deleteAgentGoalSuccess, getAgentAllDealFail, getAgentAllDealSuccess, getAgentAllTransactionFail, getAgentAllTransactionSuccess, getAgentGoalFail, getAgentGoalSuccess, getAgentTransactionFail, getAgentTransactionSuccess } from "./actions";
import { CREATE_AGENT_GOAL, DELETE_AGENT_GOAL, GET_AGENT_GOAL, GET_AGENT_TRANSACTION, GET_AGENT_TRANSACTION_DEAL, GET_AGENT_TRANSACTION_GRID } from "./actionTypes";


function* submitAgentGoal({ payload: { goal, callback } }) {
  try {
    toast.loading("Please wait...");
    const response = yield call(postGoalAPI, {
      agentId: parseInt(goal.agentId),
      goalYear: parseInt(goal.goalYear),
      transactionCount: parseInt(goal.transactionCount),
      jan: parseInt(goal.jan),
      feb: parseInt(goal.feb),
      mar: parseInt(goal.mar),
      apr: parseInt(goal.apr),
      may: parseInt(goal.may),
      jun: parseInt(goal.jun),
      jul: parseInt(goal.jul),
      aug: parseInt(goal.aug),
      sep: parseInt(goal.sep),
      oct: parseInt(goal.oct),
      nov: parseInt(goal.nov),
      dec: parseInt(goal.dec),
      goalIsActive: true
    });
    toast.dismiss();
    if (response.success === true) {
      toast.success("Goal Added Successfully");
      const res = yield call(getGoalAPI, goal.agentId);
      yield put(getAgentGoalSuccess(res));
      if (callback) {
        callback(true);
      }
    } else {
      toast.error(response.validationErrors?.[0] || "Some issue occurred");
      if (callback) {
        callback(false);
      }
    }

  } catch (error) {
    toast.dismiss();
    toast.error("Something went wrong. Please try again.");
    yield put(addNewGoalError(error));
    if (callback) {
      callback(false);
    }
  }
}

function* fetchAgentGoal({ AgentId }) {
  try {
    const response = yield call(getGoalAPI, AgentId)
    yield put(getAgentGoalSuccess(response))
  } catch (error) {
    yield put(getAgentGoalFail(error))
  }
}

function* onDelAgentGoal({ payload: goal }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(deleteGoalAPI, goal.id)
    yield put(deleteAgentGoalSuccess(response))
    toast.dismiss();
    toast.success("Goal Deleted");
    const res = yield call(getGoalAPI, goal.agentId)
    yield put(getAgentGoalSuccess(res))

  } catch (error) {
    yield put(deleteAgentGoalFail(error))
  }
}

function* fetchAgentTransaction({ agentId }) {
  try {
    const response = yield call(getTransactionAPI, agentId)
    yield put(getAgentTransactionSuccess(response))
  } catch (error) {
    yield put(getAgentTransactionFail(error))
  }
}

function* fetchAllAgentTransaction({ agentId }) {
  try {
    const response = yield call(getAllTransactionAPI, agentId)
    yield put(getAgentAllTransactionSuccess(response))
  } catch (error) {
    yield put(getAgentAllTransactionFail(error))
  }
}

function* fetchAllAgentDeal({ agentId }) {
  try {
    const response = yield call(getAllDealTransactionAPI, agentId)
    yield put(getAgentAllDealSuccess(response))
  } catch (error) {
    yield put(getAgentAllDealFail(error))
  }
}


function* transactionSaga() {
  yield takeEvery(CREATE_AGENT_GOAL, submitAgentGoal) 
  yield takeEvery(GET_AGENT_GOAL, fetchAgentGoal)
  yield takeEvery(DELETE_AGENT_GOAL, onDelAgentGoal)  
  yield takeLatest(GET_AGENT_TRANSACTION, fetchAgentTransaction)  
  yield takeEvery(GET_AGENT_TRANSACTION_GRID, fetchAllAgentTransaction) 
  yield takeEvery(GET_AGENT_TRANSACTION_DEAL, fetchAllAgentDeal)  
}

export default transactionSaga
